import { useMutation, useQuery } from '@apollo/client'
import mutationCreateVirtualModule from 'graphQL/virtualAssetManager/createVirtualModule'
import listVirtualModules from 'graphQL/virtualAssetManager/listVirtualModules'
import listAssetTypes from 'graphQL/admin/asset/listAssetTypes'
import updateVirtualModule from 'graphQL/virtualAssetManager/updateVirtualModule'

export const useListVirtualModules = (options) => {
  return useQuery(listVirtualModules, options)
}

export const useCreateVirtualModule = (options) => {
  return useMutation(mutationCreateVirtualModule, options)
}

export const useListAssetTypes = (options) => {
  return useQuery(listAssetTypes, options)
}

export const useUpdateVirtualModule = (options) => {
  return useMutation(updateVirtualModule, options)
}
